var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A41C46BF-6B01-4965-9165-3B6312F4ABC7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82C672",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#328C21",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Application--Submitted",
    transform: "translate(-720.000000, -386.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(720.000000, 386.153876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0 C3.812912,0 0,3.812912 0,8.5 C0,13.187088 3.812912,17 8.5,17 C13.187088,17 17,13.187088 17,8.5 C17,3.812912 13.187088,0 8.5,0 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3072863,5.36441042 C12.5203824,5.36441042 12.7335276,5.44583479 12.8964938,5.608801 C13.0593885,5.77169565 13.1407871,5.98480637 13.1407871,6.19791126 C13.1407871,6.41100119 13.0593987,6.62413763 12.8964926,6.78712006 L12.8964926,6.78712006 L8.29228392,11.391199 C8.12977311,11.5537098 7.91643899,11.6354599 7.703125,11.6354599 C7.48981101,11.6354599 7.27647689,11.5537098 7.11396609,11.391199 L7.11396609,11.391199 L4.8119467,9.0891796 C4.64897239,8.9262816 4.56753542,8.71312797 4.56753542,8.5 C4.56753542,8.28687203 4.64897239,8.0737184 4.8119053,7.91086179 C4.97480568,7.7478851 5.18792518,7.66645051 5.40103626,7.66645051 C5.61413238,7.66645051 5.8272776,7.74787488 5.99024382,7.91084109 L5.99024382,7.91084109 L7.7031264,9.62372367 L11.7181553,5.6088217 C11.8810557,5.44584501 12.0941752,5.36441042 12.3072863,5.36441042 Z",
    id: "Path",
    stroke: "#FAFAFA",
    strokeWidth: 0.25,
    fill: "#FAFAFA"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitCheckIcon);
export default __webpack_public_path__ + "static/media/SubmitCheckIcon.6b53d4979b30301878b812586954605c.svg";
export { ForwardRef as ReactComponent };